var map = {
	"./modelo-acai.png": "10a9",
	"./modelo-confeitaria.png": "fae2",
	"./modelo-hamburgueria.png": "4108",
	"./modelo-hortifruti.png": "ae34",
	"./modelo-marmitaria.png": "e64c",
	"./modelo-pizzaria.png": "30b8",
	"./modelo-restaurante.png": "acef",
	"./modelo-salgaderia.png": "73ae",
	"./modelo-sushi.png": "a567",
	"./tablet-acaiteria.png": "dc57",
	"./tablet-acaiteria.webp": "4ba7",
	"./tablet-bar.png": "1171",
	"./tablet-bar.webp": "0913",
	"./tablet-hamburgueria.png": "64e0",
	"./tablet-hamburgueria.webp": "5b9b",
	"./tablet-pastelaria.png": "e8a1",
	"./tablet-pastelaria.webp": "71d7",
	"./tablet-pizzaria.png": "e832",
	"./tablet-pizzaria.webp": "1645",
	"./tablet-restaurante.png": "21d8",
	"./tablet-restaurante.webp": "12dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "208f";